import Api from '@weapnl/js-junction';

Api.host(process.env.VUE_APP_API_HOST).suffix(`api`);

export default Api;
